import React from 'react';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseNtp from '../../AbstractObjects/GatewayPlan/InnerPages/BaseNtp';

const pageSchema = PlanGetSchema.pages.ntp;
const pageId = pageSchema.pageId;

function PlanNtp({
    planObject,
    setPlanData
}) {

    const pageData = planObject[pageId];

    return (
        <BaseNtp pageData={pageData} setObjectData={setPlanData} />
    );
}

export default PlanNtp;